import type { ComputedContentSource } from '@gitbook/api-client';
import { Icon, type SVGIconProps } from '@gitbook/spine-icons';

/**
 * Render an icon for a computed content source.
 */
export function ComputedSourceIcon(
    props: {
        source: ComputedContentSource;
    } & SVGIconProps
) {
    const { source, ...iconProps } = props;

    if (source.type === 'builtin:translation') {
        return <Icon.AITranslate {...iconProps} />;
    }

    if (source.type === 'builtin:openapi') {
        return <Icon.OpenAPI {...iconProps} />;
    }

    return <Icon.Zap {...iconProps} />;
}
